<template>
  <div v-if="chosenQuote">
    <div class="card card-body">
      <p>U krijgt {{ amountOfPanels }} zonnepanelen en wekt hiermee elektriciteit op. Hierdoor
        hoeft u minder elektriciteit in te kopen en gaat uw energie rekening
        met {{ $options.filters.formatCurrency(yearlySavings) }} per jaar omlaag.</p>
      <p>U houdt dit geld over voor andere uitgaven EN u draagt bij aan het milieu!</p>
      <div>
        <b-row>
          <b-col cols="12" lg="6">
            <b-row>
              <b-col cols="12" class="mb-2">
                <span>Gemiddelde opbrengst per maand<sup>1</sup></span>
                <span class="float-right">{{ $options.filters.formatCurrency(monthlyRevenue) }}</span>
              </b-col>
              <b-col cols="12">
                <span>Maandelijkse bijdrage<sup>2</sup></span>
                <span class="float-right">{{ ` - ${$options.filters.formatCurrency(chosenQuote.detailOverview.monthlyPayment)}`}}</span>
              </b-col>
              <b-col>
                <hr>
                <span>Gemiddelde besparing per maand</span>
                <span class="float-right">{{ $options.filters.formatCurrency(monthlySavings) }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="4" class="text-center mt-4 mt-md-0">
            Besparing<br><h2 class="text-primary mt-2">{{$options.filters.formatCurrency(yearlySavings) }}</h2>per jaar
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="mt-4">
        <p class="font-size-sm disclaimer">
          1. Gemiddelde besparing op uw stroomkosten per maand. De gemiddelde besparing op uw stroomkosten
          is gebaseerd op {{ chosenQuote.detailOverview.energyPrice | formatCurrency(2) }} per kWh. Dit is de gemiddelde prijs
          die we in Nederland betalen voor stroom van leveranciers als Nuon en Essent. De werkelijke besparing hangt
          af van de kWh-prijs van uw stroomleverancier. U kunt dit bedrag berekenen door de gegarandeerde
          jaaropbrengst van uw zonnepanelen te vermenigvuldigen met de kWh-prijs van uw stroomleverancier. Als
          u dit bedrag vervolgens deelt door 12 maanden, weet u wat u per maand bespaart op uw stroomkosten.
        </p>
        <p class="font-size-sm disclaimer">2. Het termijnbedrag wordt apart van uw huur in rekening gebracht</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'B2bConfirmationSavingsDetail',
  computed: {
    monthlyRevenue() {
      return (this.chosenQuote.detailOverview.energyGenerated[0] / 12) * this.chosenQuote.detailOverview.energyPrice
    },
    monthlySavings() {
      return this.monthlyRevenue - this.chosenQuote.detailOverview.monthlyPayment
    },
    yearlySavings() {
      return this.monthlySavings * 12
    },
    amountOfPanels() {
      return this.chosenQuote.panels.quantity
    },
  }
}
</script>
